import React, { useState } from "react";
import "../Styles/style.css";
import FormVector from "../../images/formVector.png";
import InputMask from "react-input-mask";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Modal, Box } from "@mui/material";
import TimerLoader from "../../images/timer.gif";
import { baseUrl } from "../../api/ipconfig";

const successModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  minHeight: "10%",
  maxHeight: "95%",
  height: "auto",
  overflowY: "scroll",
};

export default function SubscriberForm() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const history = useHistory();

  const SubscriberSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const token = localStorage.getItem("token");

      const formData = new FormData();

      formData.append("subscriber_name", fullName);
      formData.append("subscriber_phone", phone);
      formData.append("subscriber_email", email);

      const response = await axios.post(`${baseUrl}/savesubscriber`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setIsSubmitting(false);

      history.push(`/`);
    } catch (err) {
      console.error(err.response);
      setIsSubmitting(false);
    }
  };

  return (
    <>

      <Modal
        open={isSubmitting}
        onClose={() => setIsSubmitting(false)}
        disableAutoFocus={true}
        className="timerModal"
      >
        <Box className="text-center successModal " sx={successModal}>
          <img
            className="modalLoaderImg"
            src={TimerLoader}
            alt="Loading..."
            srcSet=""
          />
        </Box>
      </Modal>

      {/* submitting modal */}

      <div>
        <div className="container">
          <div className="row py-5">
            <div className="memberFormHead">
              <h2 className="pb-4 color-secondary text-center">
                Subscribe To <br />
                <span className=" color-primary ">Famewheels Live Bidding</span>
              </h2>
            </div>
            <div className="col-lg-6 memberFormHead">
              <img src={FormVector} alt="payment methods" />
            </div>
            <div className="col-lg-6 d-flex align-items-center justify-content-center">
              <div className="boxShadow rounded px-4 py-5">
                <form onSubmit={SubscriberSubmit}>
                  <div className="row mb-3">
                   
                    <div className="col-md-6 col-12 mb-2">
                      <div className="mb-md-3">
                        <label for="memberName" className="form-label">
                          Full Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="ppmpf_1"
                          id="memberName"
                          placeholder="Enter Your Full Name"
                          required
                          value={fullName}
                          onChange={(e) => setFullName(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-md-6 col-12 mb-2">
                      <div className="mb-md-3">
                        <label for="memberContact" className="form-label">
                          Phone Number
                        </label>
                        <InputMask
                          mask="03999999999"
                          maskChar={null}
                          type="text"
                          name="ppmpf_3"
                          className="form-control"
                          id="memberContact"
                          placeholder="03xxxxxxxxx"
                          required
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 col-12 mb-3">
                      <div className="mb-md-3">
                        <label for="memberEmail" className="form-label">
                          Email Address
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          name="ppmpf_2"
                          id="memberEmail"
                          placeholder="Enter Your Email Address"
                          required
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-12 p-0 text-center">
                      <button
                        type="submit"
                        className="btn mt-3 fw-primary model_loginBTn px-4 py-1 fw-500 fs-5"
                      >
                        Subscribe
                      </button>
                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
